<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Correct' }" replace>待批改</el-breadcrumb-item>
				<el-breadcrumb-item>按题目批改</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="p_flex p_m_t_30" :style="{ height: height + 'px' }">
			<div class="p_f_1">
				<div class="box_head p_flex p_f_a p_f_b">
					<div id="" v-if="DataInfo.job_type == 2">
						<el-button type="warning" size="small" v-if="look"  @click="look = false">看试卷</el-button>
						<el-button type="warning" size="small" v-if=" !look" @click="look = true">去批改</el-button>
					</div>
					<span v-else></span>
					<div>
						<el-button v-if="DataInfo.student_upper != 0"  type="info" size="small" @click="question(1)">上一位</el-button>
						<el-button v-if="DataInfo.student_next != 0" type="success" size="small" @click="question(2)">下一位</el-button>
					</div>
				</div>
				<div class="box_center" :style="{ height: height - 60 + 'px' }">
					<topic-deatils v-if="look"  ref="topicdeatils" :jsix="jsix" @uile="uile" :num="num" :vm='vm'></topic-deatils>
					<div v-if="look" class="content_list small_hand">
						<div class="content_box p_b_b p_b_l p_b_t " @click="goTopic" v-show="jksid == 3 ? true : false">
							<div class="p_flex p_f_c zi_ti subject_yellow"><img src="../../../assets/img/grade.png" /></div>
							<span class="p_flex p_f_c">评分</span>
						</div>
						<div class="content_box  p_b_l p_b_t " v-show="jksid == 1 ? true : false">
							<span class="p_flex p_f_c">{{ branch }}分</span>
						</div>
						<div class="content_box p_b_l " :class="[jksid == 2 ? 'p_b_t p_b_b' : '']" v-show="jksid == 3 ? true : jksid == 2 ? true : false" @click="dialawrongnumber">
							<div class="p_flex p_f_c zi_ti"><img src="../../../assets/img/error.png" /></div>
							<span class="p_flex p_f_c">打错</span>
						</div>
						<div class="content_box p_b_b p_b_l p_b_t " v-show="jksid == 3 ? true : jksid == 2 ? false : true" @click="answer">
							<div class="p_flex p_f_c zi_ti subject_color"><img src="../../../assets/img/right.png" /></div>
							<span class="p_flex p_f_c">答对</span>
						</div>
					</div>
					<div  v-if="DataInfo.job_type == 2" :class="[look?'':'hea']" >
						 <div style="height: 100%;"  v-if=" !look">
							<div style="height: 100%;"  v-if="DataInfo.job_publish.exercise_book_file_type == 1">
								<view-iform :url="DataInfo.job_publish.exercise_book_file_url"></view-iform>
							</div>
							<div style="height: 100%;"  v-if="DataInfo.job_publish.exercise_book_file_type == 2">
								<view-iform :url="'https://view.officeapps.live.com/op/view.aspx?src=' + DataInfo.job_publish.exercise_book_file_url"></view-iform>
							</div>
							<div style="height: 100%;" v-if="DataInfo.job_publish.exercise_book_file_type == 3">
								<view-picture :url="DataInfo.job_publish.exercise_book_file_url"></view-picture>
							</div>
						 </div>
					</div>
				</div>
			</div>
			<div class="p_m_l_30 left_box overflow" :style="{ height: height - 80 + 'px' }"><detail-list @correct="correct"></detail-list></div>
		</div>
		<topic-up :show="show" :p="p" :v="v" :branch="branch" @closes="closes" @goButton="goButton"></topic-up>
	</div>
</template>

<script>
import DetailList from './commponents/detailList.vue';
import TopicDeatils from './commponents/deatils.vue';
import TopicUp from './commponents/topicUp.vue';
import ViewIform from './commponents/iform.vue'
import ViewPicture from './commponents/picture.vue'
export default {
	name: 'Topic',
	components: {
		DetailList,
		TopicDeatils,
		TopicUp,
		ViewIform,
		ViewPicture
	},
	data() {
		return {
			height: 0,
			show: false,
			look: true,
			jsix: {},
			jksid: '', //答题还是没答题状态
			branch: '', //分数
			num: 0,
			p: '', //学生答题id
			v: '' ,//学生id，
	        DataInfo:{},
			vm:this
		};
	},
	mounted() {
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Topic') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	methods: {
		answer() {
			//正确
			if (this.jksid == 1) {
				this.$message.error('此学生本题目已批改！请下一个学生');
				return;
			}
			this.$confirm('确认批改吗', '批改', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.show = true;
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
		},
		dialawrongnumber() {
			//打错
			if (this.jksid == 2) {
				this.$message.error('此学生本题目已批改！请下一个学生');
				return;
			}
			this.$confirm('确认批改吗', '批改', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.piGaiInfo();
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
		},
		// 批改
		piGaiInfo() {
			this.$request
				.ajax(this)
				.post('/api_teacher/homework_correcting', {
					job_record_id: this.p,
					student_id: this.v,
					score: 0,
					result: 2 //1.正确，2.错误
				})
				.then(res => {
					// console.log(res)
					this.$message({
						type: 'success',
						message: res.msg
					});
					this.jksid = 2;
				});
		},
		uile(val, o, p, v,data) {
			// console.log(val)
			this.jksid = val; //状态
			this.branch = o.toString(); // 分数
			this.p = p.toString();
			this.v = v.toString();
			this.DataInfo = data
		},
		question(id) {
            if( id == 1 ){
				this.$refs.topicdeatils.getInfo(id)
			}else{
				if( this.jksid == 2 || this.jksid == 1 ){
					this.$refs.topicdeatils.getInfo(id)
				}else{
					this.$message.error('您还未批改！');
				}
			}




		},
		correct(val) {
			// console.log(val)
			this.jsix = val;
		},
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		goTopic() {
			this.show = true;
		},
		closes(val) {
			this.show = val;
		},
		goButton(val, i, name) {
			this.branch = name;
			this.jksid = i;
			this.show = val;
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.left_box {
	width: 380px;
	background-color: #ffffff;
}
.box_head {
	height: 60px;
	padding: 0 60px;
	background-color: #fafafa;
}
.box_center {
	position: relative;
	background-color: #ffffff;
	padding: 0 60px;
}
.content_list {
	position: absolute;
	bottom: 100px;
	right: 0;
}
.content_box {
	padding: 16px;
	font-size: 12px;
}
.zi_ti {
	width: 30px;
	height: 30px;
	margin-bottom: 5px;
}
>>> .el-button--primary {
	background-color: #00af63;
	border-color: #00af63;
}
img{
	width: 100%;
	height: 100%;
}
.hea{
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/correct/topic.vue